import { DateCellType } from './date.types';

export const getDatesToRender = (currentDate: Date) => {
  const totalDays = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();

  const totalDaysOfPrevMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    0,
  ).getDate();

  const daysInCurrentMonth = Array.from({ length: totalDays }, (_, i) => ({
    date: i + 1,
    isDisabled: false,
    timeStamp: new Date(currentDate.getFullYear(), currentDate.getMonth(), i + 1).getTime(),
  })) as DateCellType[];

  const daysOfPrevMonth = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    const value: DateCellType = {
      date: totalDaysOfPrevMonth - i,
      isDisabled: true,
      timeStamp: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        totalDaysOfPrevMonth - i,
      ).getTime(),
    };

    daysOfPrevMonth.push(value);
  }

  const days = [...daysOfPrevMonth.reverse(), ...daysInCurrentMonth];

  let i = 1;
  while (days.length % 7 !== 0) {
    const value: DateCellType = {
      date: i,
      isDisabled: true,
      timeStamp: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i).getTime(),
    };
    days.push(value);
    i++;
  }
  return days;
};

export const isTwoDatesEqual = (date1: Date, date2: Date) =>
  date1.getDate() === date2.getDate() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getFullYear() === date2.getFullYear();
